import { render, staticRenderFns } from "./odeme_gecmisi.vue?vue&type=template&id=25295042"
import script from "./odeme_gecmisi.vue?vue&type=script&lang=js"
export * from "./odeme_gecmisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports